import { ExportColumn, ExportOptions } from '../../types';
import hasTextExportDecoration from '../hasTextExportDecoration';
import { isNumberExportColumn } from '../isNumberExportColumn';
import resolveNumberValue from '../resolveNumberValue';
import resolveRoundedValue from '../resolveRoundedValue';

// A real Number cell can't carry a prefix/suffix, a forced decimal separator,
// or display-formatting decoration, so those cases fall back to the text path.
const resolveXlsxCellNumber = (
  row: Record<string, unknown>,
  column: ExportColumn,
  options: ExportOptions
): number | undefined => {
  if (!isNumberExportColumn(column)) {
    return undefined;
  }

  if (options.useDisplayFormatting || options.decimalSeparator !== 'display') {
    return undefined;
  }

  if (hasTextExportDecoration(column.exportOptions)) {
    return undefined;
  }

  const rawValue = row[column.name];

  // Number('') is 0, so an empty value must be excluded before rounding/parsing.
  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return undefined;
  }

  return resolveNumberValue(
    resolveRoundedValue(rawValue, column.exportOptions)
  );
};

export default resolveXlsxCellNumber;
